import React from "react";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import { Container, HeaderContainer, BodyContainer, FooterContainer } from "./_cardStyle";
import cn from "classnames";

// TODO: Make card component type-safe, it is kind of scary to use because it isn't type-safe at the moment
export type CardProps = SpacingStyle & {
  border?: boolean;
  radius?: number;
  shadow?: boolean;
  zoom?: boolean;
  width?: string;
  height?: string;
  direction?: string;
  children?: React.ReactNode;
};

type Card = {
  displayName?: string;
  Header?: (props: any) => JSX.Element;
  Footer?: (props: any) => JSX.Element;
  Body?: (props: any) => JSX.Element;
  defaultProps?: any;
  children: React.ReactNode;
  className?: string;
};

const Card: Card = React.forwardRef<any, CardProps>((props, ref) => {
  const { children, className, ...rest } = props;

  return (
    <Container ref={ref} className={cn("card-container", className)} {...rest}>
      {children}
    </Container>
  );
});

Card.displayName = "Card";

const Header = (props: any) => {
  const { src, children, ...rest } = props;

  return (
    <HeaderContainer className="card-header-container" src={src} {...rest}>
      {children}
    </HeaderContainer>
  );
};

const Body = (props: any) => {
  const { children, ...rest } = props;

  return (
    <BodyContainer className="card-body-container" {...rest}>
      {children}
    </BodyContainer>
  );
};

const Footer = (props: any) => {
  const { children, ...rest } = props;

  return (
    <FooterContainer className="card-footer-container" {...rest}>
      {children}
    </FooterContainer>
  );
};

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

Card.defaultProps = {
  border: false,
  shadow: false,
  radius: 8,
  zoom: false,
  width: "auto",
  height: "auto",
  direction: "column",
};

export default Card;
